export const shortenLogsName = (logGroupName?: string): string | undefined =>
  logGroupName?.split('-', 4)[3] || logGroupName
